import * as Base from "./InterfaceBase";
export class KontoNumUtils {
    static KASSE_3_MIN = 1000;
    static KASSE_3_MAX = 1099;
    static KASSE_4_MIN = 1600;
    static KASSE_4_MAX = 1699;
    static BANK_3_MIN = 1100;
    static BANK_3_MAX = 1288;
    static BANK_4_MIN = 1700;
    static BANK_4_MAX = 1888;
    static SALDO_MIN = 9000;
    static SALDO_MAX = 9100;
    static GELDTRANSIT_3_MIN = 1360;
    static GELDTRANSIT_3_MAX = 1369;
    static GELDTRANSIT_4_MIN = 1460;
    static GELDTRANSIT_4_MAX = 1469;
    static CAT_DEB_3 = 1400;
    static CAT_DEB_RANGE_3_MIN = 1401;
    static CAT_DEB_RANGE_3_MAX = 1459;
    static CAT_DEB_4 = 1200;
    static CAT_DEB_RANGE_4_MIN = 1201;
    static CAT_DEB_RANGE_4_MAX = 1229;
    static CAT_CRED_3 = 1600;
    static CAT_CRED_RANGE_3_MIN = 1601;
    static CAT_CRED_RANGE_3_MAX = 1658;
    static CAT_CRED_4 = 3300;
    static CAT_CRED_RANGE_4_MIN = 3301;
    static CAT_CRED_RANGE_4_MAX = 3348;
    static CAT_SKONTO_CRED_3 = 3730;
    static CAT_SKONTO_CRED_4 = 5730;
    static CAT_SKONTO_DEB_3 = 8730;
    static CAT_SKONTO_DEB_4 = 4730;
    static LA_3 = 1755;
    static LA_4 = 3790;
    static DEB_MIN = 10000;
    static DEB_MAX = 69999;
    static KRED_MIN = 70000;
    static KRED_MAX = 99999;
    static isCreditor(creditor, ext) {
        return this.checkAccountRangeSoft(creditor, ext, [this.KRED_MIN, this.KRED_MAX], Base.KontoDefaultLen.Creditor);
    }
    static isCreditorStrict(creditorNum, ext) {
        return this.checkAccountRangeStrict(creditorNum, this.adjustRange([this.KRED_MIN, this.KRED_MAX], ext));
    }
    static adjustRange(range, ext) {
        const [min, max] = range;
        return [
            Number(String(min).padEnd(String(min).length + ext, "0")),
            Number(String(max).padEnd(String(max).length + ext, "9")),
        ];
    }
    static isCategoryRepresentingCreditor(account, skr, ext) {
        return this.checkAccountRangeStrict(account?.stringNum || account?.extNum?.getExtNum(ext) || "", this.adjustRange(skr === 3
            ? [this.CAT_CRED_RANGE_3_MIN, this.CAT_CRED_RANGE_3_MAX]
            : [this.CAT_CRED_RANGE_4_MIN, this.CAT_CRED_RANGE_4_MAX], ext));
    }
    static isDebitor(debitor, ext) {
        return this.checkAccountRangeSoft(debitor, ext, [this.DEB_MIN, this.DEB_MAX], Base.KontoDefaultLen.Creditor);
    }
    static isDebitorStrict(debitorNum, ext) {
        return this.checkAccountRangeStrict(debitorNum, this.adjustRange([this.DEB_MIN, this.DEB_MAX], ext));
    }
    static isCategoryRepresentingDebitor(account, skr, ext) {
        return this.checkAccountRangeStrict(account?.stringNum || account?.extNum?.getExtNum(ext) || "", this.adjustRange(skr === 3
            ? [this.CAT_DEB_RANGE_3_MIN, this.CAT_DEB_RANGE_3_MAX]
            : [this.CAT_DEB_RANGE_4_MIN, this.CAT_DEB_RANGE_4_MAX], ext));
    }
    static isKasseStrict(categoryNum, skr, ext) {
        return this.checkAccountRangeStrict(categoryNum, this.adjustRange(skr === 3 ? [this.KASSE_3_MIN, this.KASSE_3_MAX] : [this.KASSE_4_MIN, this.KASSE_4_MAX], ext));
    }
    static isBankStrict(categoryNum, skr, ext) {
        return this.checkAccountRangeStrict(categoryNum, this.adjustRange(skr === 3 ? [this.BANK_3_MIN, this.BANK_3_MAX] : [this.BANK_4_MIN, this.BANK_4_MAX], ext));
    }
    static isMoneyTransit(categoryNum, skr, ext) {
        return this.checkAccountRangeStrict(categoryNum, this.adjustRange(skr === 3
            ? [this.GELDTRANSIT_3_MIN, this.GELDTRANSIT_3_MAX]
            : [this.GELDTRANSIT_4_MIN, this.GELDTRANSIT_4_MAX], ext));
    }
    static isLACat(categoryNum, skr, ext) {
        return this.checkAccountRangeStrict(categoryNum, this.adjustRange(skr === 3 ? [this.LA_3, this.LA_3] : [this.LA_4, this.LA_4], ext));
    }
    static getExtNum(num, ext, defaultLen) {
        if (typeof num === "number") {
            num = String(num);
        }
        if (typeof num !== "string" || num === "") {
            return "";
        }
        if (num.length < defaultLen) {
            return num;
        }
        const intendedLen = defaultLen + ext;
        if (num.length > intendedLen) {
            num = num.substring(0, intendedLen);
        }
        return num + "00".substring(0, defaultLen + ext - num.length);
    }
    static equalsTo(a, b) {
        const ae = Number(Boolean(a));
        const be = Number(Boolean(b));
        // eslint-disable no-bitwise
        if (ae ^ be) {
            return false;
        }
        if (!a && !b) {
            return true;
        }
        const aMax = this.getExtNum(a.num, a.getDefaultLen(), Base.CompanyKontoExtMax);
        const bMax = this.getExtNum(b.num, b.getDefaultLen(), Base.CompanyKontoExtMax);
        return aMax === bMax;
    }
    static getExtNumPrint(num, ext, defaultLen) {
        if (typeof num !== "string" || num === "") {
            return "";
        }
        if (num.length < defaultLen) {
            return num;
        }
        num = this.getExtNum(num, ext, defaultLen);
        if (num.length === defaultLen) {
            return num;
        }
        return num.substring(0, defaultLen) + " " + num.substring(defaultLen, defaultLen + num.length);
    }
    static fixNum(v, ext, defaultLen) {
        if (!v.num) {
            return v;
        }
        if (v.num.length === defaultLen + ext) {
            return v;
        }
        return Object.assign(v, { num: this.getExtNum(v.num, ext, defaultLen) });
    }
    static merge(collection1 = [], collection2 = [], ext) {
        const cMap = new Map();
        collection1.forEach(c => cMap.set(c.getExtNum(ext), c));
        collection2.forEach(c => {
            if (!c) {
                console.log(collection2);
                if (process.env.NODE_ENV !== "production") {
                    throw new Error("empty element in collection");
                }
                return;
            }
            cMap.set(c.getExtNum(ext), c);
        }, {});
        return Array.from(cMap.values());
    }
    static checkAccountRangeStrict(accountNum, range) {
        const num = Number(accountNum);
        const [min, max] = range;
        return num >= min && num <= max;
    }
    static checkAccountRangeSoft(account, ext, range, defaultLen) {
        if (!account) {
            return false;
        }
        if (!account.stringNum && !account.extNum) {
            return false;
        }
        const getShortNum = () => {
            if (account.stringNum) {
                return account.stringNum.substring(0, defaultLen);
            }
            if (account.extNum) {
                const extNum = account.extNum.getExtNum(ext);
                return extNum.substring(0, extNum.length - ext);
            }
            throw new Error("can't find num in object", { cause: account });
        };
        const shortNum = getShortNum();
        if (shortNum.length === defaultLen) {
            const [min, max] = range;
            if (Number(shortNum) >= min && Number(shortNum) <= max) {
                return true;
            }
        }
        return false;
    }
}
//# sourceMappingURL=KontoNumUtils.js.map